import type { IContainer } from '../../interface/container';
import updateSiteBinder from './updateSite/updateSite.bind';
import downloadBinder from './download.bind';
import deleteBinder from './delete.bind';
import type { IJobs } from '../interface';

function bind(container: IContainer): IJobs {
    const tasks: IJobs = {
        updateSite: updateSiteBinder(container),
        downloadMedia: downloadBinder.downloadMedia(container),
        downloadMediaNoResponse: downloadBinder.downloadMediaNoResponse(container),
        deleteMedia: deleteBinder.deleteMedia(container),
    };

    return tasks;
}

export default bind;
